import { render, staticRenderFns } from "./Game3.vue?vue&type=template&id=726c0318&scoped=true&"
import script from "./Game3.vue?vue&type=script&lang=js&"
export * from "./Game3.vue?vue&type=script&lang=js&"
import style0 from "./Game3.vue?vue&type=style&index=0&lang=css&"
import style1 from "./Game3.vue?vue&type=style&index=1&lang=css&"
import style2 from "./Game3.vue?vue&type=style&index=2&id=726c0318&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "726c0318",
  null
  
)

export default component.exports